<div class="background w-screen h-screen bg-cover bg-center bg-no-repeat flex flex-col justify-center md:flex-none md:justify-normal" style="background-image: url('./../../assets/login-background.png');">
    <div class="header-container font-semibold  flex-col items-start justify-around text-white pl-12 hidden md:flex pt-[5vh]">
        <h1 class="text-[3.5vw] pt-1">Onboarding Digital</h1>
        <div class="w-1/3">
            <p class="text-[1.25vw] pt-1">Plataforma para validación de documentación e identidad, DNI, tarjetas de crédito y seguros</p>
        </div>
    </div> 
    
    <div class="login-container md:fixed md:bottom-0 md:right-0 flex justify-center items-center md:justify-end md:items-end text-center max-h-full">
        <div class="login flex flex-col  md:justify-evenly items-center h-full bg-opacity-100 rounded md:rounded-tl-2xl w-3/4 md:w-[30vw] md:h-[65vh] max-h-full md:max-h-[65vh] px-8">
            
            <div class="title-container p-5 md:p-0 md:pb-[3vh]">
                <h2 class="font-semibold md:text-[1.8vw] mb-1 text-title-color">¡Bienvenido!</h2>
                <p class="hidden md:block md:text-[1.1vw] text-text-color">Inicia sesión con tu cuenta</p>
            </div>
            
            <div class="form-container w-full">
                <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
                    <div class="form-items flex flex-col items-center gap-3 md:gap-2">
                        <mat-form-field appearance="outline" class="w-full" >
                            <mat-label>Ingrese su correo</mat-label>
                            <input matInput placeholder="test@test.com" formControlName="username" />
                            <mat-icon matSuffix class="text-title-color">person</mat-icon>
                            <mat-error class="text-error text-xs ">El email ingresado no es válido</mat-error>
                        </mat-form-field>
                        
                        <mat-form-field appearance="outline" class="w-full">
                            <mat-label>Ingresa tu contraseña</mat-label>
                            <input matInput formControlName="password" placeholder="****" [type]="passwordInputType" />
                            <button mat-icon-button matSuffix (click)="changePasswordInputType()" type="button">
                                <mat-icon class="text-title-color">{{ passwordIcon }}</mat-icon>
                            </button>
                            <mat-error class="text-error text-xs">La contraseña ingresada es inválida</mat-error>
                        </mat-form-field>
                        
                        <button mat-flat-button class="mt-2 rounded-2xl text-white font-bold text-[1vw] login-button w-3/4">Ingresar</button>
                    </div>
                </form>
            </div>
            
            @if (showErrorMessage) {
                <div class="error-text-container text-center text-error">
                    <p>Los datos ingresados no son correctos, por favor vuelva a intentarlo</p>
                </div>
            }
            
            <div class="footer-container flex flex-row items-center justify-center gap-3 md:gap-5 w-full py-3 md:py-0">
                <img src="../../../assets/obd-logo.svg" alt="OBD-LOGO" class="w-8 md:w-10" />
                <h2 class= "text-[3vw] md:text-[1.2vw] text-text-color mb-0">Onboarding Digital</h2>
            </div>
        </div>
    </div>
</div>
 